import React from "react";
import PropTypes from "prop-types";
import ButtonWithIcon from 'react/components/ButtonWithIcon';

const ButtonWithDropdown = ({ style, styles, isActive, dropdown, onClick, ...others}) => (
  <span 
  className={`button-with-dropdown-component ${isActive ? 'button-with-dropdown-component--is-active' : ''}`}
  style={style || styles.base}
  onClick={onClick}>
    <ButtonWithIcon isActive={isActive} styles={styles} {...others}/>
    { 
      isActive &&
      <span className="button-with-dropdown-component-dropdown" style={styles.dropdown}>
        {dropdown}
      </span>
    }
  </span>
);

ButtonWithDropdown.propTypes = {
  dropdown: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  style: PropTypes.object,
  isActive: PropTypes.bool.isRequired,
  styles: PropTypes.object,
  onClick: PropTypes.func
};

ButtonWithDropdown.defaultProps = {
  styles: {}
}

export default ButtonWithDropdown;
